import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=b9e02ef2&scoped=true&"
var script = {}
import style0 from "./Organizations.vue?vue&type=style&index=0&id=b9e02ef2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e02ef2",
  null
  
)

export default component.exports